import Mixpanel from 'mixpanel-browser';
import { match } from 'ts-pattern';

export const initMetrics = (): void => {
  if (import.meta.env.PROD) {
    Mixpanel.init(
      match(import.meta.env.VITE_LIZA_STAGE)
        .with('production', () => '39a8b7d374acdd7701a8919c53110fde')
        .otherwise(() => '1a354474454b7ed313b2644fdfd5dfc6'),
      {
        autocapture: false,
        record_block_selector: 'img, video, audio',
        record_heatmap_data: true,
        record_mask_all_text: true,
        record_sessions_percent: 100,
        track_pageview: true,
      },
    );
  } else {
    // oxlint-disable-next-line no-console
    console.log('Metrics not initialized in development');
  }
};

export const LLM_FEEDBACK_EVENTS = {
  positive: 'llm_response_feedback_positive',
  negative: 'llm_response_feedback_negative',
} as const;

export const trackEvent = (event: string, properties?: Record<string, unknown>): void => {
  if (import.meta.env.PROD) {
    // Uninitialized Mixpanel throws on track — the case in any production-mode
    // build that never calls initMetrics (Chromatic's Storybook build) — and an
    // analytics failure must never break the interaction that fired it.
    try {
      Mixpanel.track(event, properties);
    } catch {
      // Drop the event.
    }
  } else {
    // oxlint-disable-next-line no-console
    console.log('Metrics disabled in development', event, properties);
  }
};

type User = {
  id: string;
};

export const setUser = (user: User): void => {
  if (import.meta.env.PROD) {
    Mixpanel.identify(user.id);
  } else {
    // oxlint-disable-next-line no-console
    console.log('Metrics disabled in development');
  }
};
